import i18n from "./messages/i18n";
import { ROUTE_HOME } from "./constants";

export const updateTitle = route => {
  let title = i18n.t("title");
  title +=
    route.name === ROUTE_HOME ? "" : " : " + i18n.t("navigation." + route.name);
  if (title) {
    document.title =
      title +
      (route.params.hasOwnProperty("name") ? " " + route.params.name : "");
  }
};

export const randomKey = () => {
  return btoa(+new Date() * Math.random());
};

export const isEmptyObject = obj => {
  return !obj || Object.keys(obj).length === 0;
};

export const removeAccentsFromString = str => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const moveBetweenArrays = (value, fromArray, toArray) => {
  let found = false;
  for (const key in fromArray) {
    if (fromArray[key] === value) {
      found = true;
      fromArray.splice(key, 1);
      break;
    }
  }
  if (found) {
    toArray.push(value);
  }
};

export const sortObjectKeysBySubProperty = (obj, options) => {
  // sorted by subproperty "name" ascending by default, but overwritten by options object
  const sort = {
    by: "name",
    desc: false,
    ...options
  };
  let arr = [];
  for (const [key, props] of Object.entries(obj)) {
    arr.push({
      key,
      t: props[sort.by]
    });
  }
  arr.sort((a, b) => {
    if (isNaN(a.t) || isNaN(b.t)) {
      // const rule = a.t > b.t ? 1 : -1;
      // return sort.desc ? -1 * rule : rule;
      return sort.desc ? b.t.localeCompare(a.t) : a.t.localeCompare(b.t);
    }
    return sort.desc ? b.t - a.t : a.t - b.t;
  });
  return arr;
};

export const searchInObjectSubProperties = (obj, query, options) => {
  if (typeof query !== "string" || query == "") {
    return [];
  } else {
    query = query.toLowerCase();
  }
  options = {
    allowedProps: [],
    ...options
  };
  let arr = [];
  for (const [key, props] of Object.entries(obj)) {
    for (const [prop, val] of Object.entries(props)) {
      if (
        (!options.allowedProps.length || options.allowedProps.includes(prop)) &&
        typeof val === "string" &&
        removeAccentsFromString(val.toLowerCase()).includes(
          removeAccentsFromString(query)
        )
      ) {
        arr.push({ key, prop });
        break;
      }
    }
  }
  return arr;
};
